import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import {getModalKmVsRutas } from '../integracionDashboard';
import { InputText } from 'primereact/inputtext';

const ModalKmVsRutas = ({ title, visible, onHide,id}) => {
  const [data, setData] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [loading, setLoading] = useState(true);
      const onGlobalFilterChange = (e) => {
        setGlobalFilterValue(e.target.value);
      };
      const renderHeader = () => {
        return (
          <div className="table-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span className="p-input-icon-left">
              <i className="pi pi-search" style={{paddingLeft:'20px'}}/>
              <InputText
                type="search"
                onChange={onGlobalFilterChange}
                placeholder="Buscar..."
                value={globalFilterValue}
                style={{paddingLeft:'40px'}}
              />
            </span>
            {/* <Button label='Descargar exel' onClick={()=>{BotonDescargarExel()}}></Button> */}
          </div>
        );
      };
  useEffect(() => {
    if (visible) {
      getModalKmVsRutas(setData,setLoading)
    }
    if(!visible)
    {
      setLoading(true)
      setData([])
    }
  }, [visible])

  return (
    <Dialog header={title} visible={visible}  headerStyle={{background:"white",color:"black"}} headerClassName='colorex' style={{ width: '80vw' }} modal onHide={onHide}>
      <DataTable value={data} paginator rows={5}  globalFilter={globalFilterValue} header={renderHeader()} loading={loading}>
        <Column field="ID_RUTA" header="ID_RUTA" />
        <Column field="NOMBRE" header="NOMBRE" />
        <Column field="KM_CONTRATADOS" header="KM_CONTRATADOS" />
        <Column field="ID_TRAZO" header="ID_TRAZO" />
        <Column field="KM_TRAZO" header="KM_TRAZO" />
        <Column field="TRAZADO_VS_CONTRATADO" header="TRAZADO_VS_CONTRATADO" />
      </DataTable>
    </Dialog>
  );
};

export default ModalKmVsRutas;
